<template>
  <div id="home">
    <div class="container">
      <Logo />
      <Social />
    </div>
  </div>
</template>

<script>
import Social from '../components/Social.vue';
import Logo from '../components/Logo.vue';
export default {
  name: 'Home',
  components: {
    Social,
    Logo
  }
};
</script>

<style lang="scss">
#home {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

